import info from "./status";
import $ from "jquery";

const module = (window as any).$sk.template;
import { GetUrl } from "./getUrl";
import { meetingService } from "../services/meeting";
import { cr, ck, URLS } from "fire-wind-water";
import { UserEventParameter } from "./interface";
const getUrl = new GetUrl();
ck.json = true;
const sconf = (window as any).$sk.config;
class User {
  info: any = {};
  isMobile = !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i);
  customFormId: string = URLS.getURL("customFormId");
  tc: string = URLS.getURL("tc");
  markCode: string = URLS.getURL("markCode");
  webinarInfo: any = null;
  static modules: { [label: string]: string | any }[] = [];
  constructor() {
    module.module(this);
    this.initSubscribe();
  }

  module(o) {
    const key = `sk_temp_webinar_user_${new Date().getTime()}`;
    User.modules.push({
      key,
      model: o,
    });
    return {
      unsubscribe() {
        User.modules = User.modules.filter((d) => {
          return d.key !== key;
        });
      },
    };
  }

  // 开启监听
  initSubscribe() {
    //监听到 会议信息后 初始化用户信息
    info.meeting.initEdn.subscribe((res) => {
      this.webinarInfo = res;
      this.init(res);
    });
  }

  init(option, b?: boolean) {
    if (b) {
      console.log(b);
    }
    this.userLoad(option).then(async (userInfo) => {
      //用户信息 回调 验证用户状态
      if (
        !this.webinarInfo.isClosed &&
        this.info.hasPermission != undefined &&
        this.info.isDelete != undefined &&
        (!this.info.hasPermission || this.info.isDelete)
      ) {
        //验证用户状态
        if (this.info.permission == 2) {
          this.skWebinarUserChange({
            type: "kickOut",
            data: {
              needLogin: false,
              needSignUp: false,
              message: "您的报名信息正在审核，请等待！",
            },
          });
          return;
        } else if (this.info.permission == 0) {
          this.skWebinarUserChange({
            type: "kickOut",
            data: {
              needLogin: false,
              needSignUp: false,
              message: "很抱歉！您未通过报名审核！",
            },
          });
          return;
        } else {
          this.skWebinarUserChange({
            type: "kickOut",
            data: {
              needLogin: false,
              needSignUp: false,
              message: "很抱歉，您没有权限观看本场会议！",
            },
          });
          return;
        }
      }
      if (
        !this.webinarInfo.isClosed &&
        !this.webinarInfo.unLimit &&
        this.webinarInfo.needLogin &&
        !userInfo.isLogin &&
        !this.webinarInfo.isClosed &&
        !this.webinarInfo.unLimit &&
        this.webinarInfo.needRegistration &&
        !this.info.isRegistration
      ) {
        await getUrl.goToLogin(this.webinarInfo, userInfo);
        await getUrl.goToSignUp(this.webinarInfo);
      } else if (
        !this.webinarInfo.isClosed &&
        !this.webinarInfo.unLimit &&
        this.webinarInfo.needLogin &&
        !userInfo.isLogin
      ) {
        await getUrl.goToLogin(this.webinarInfo, userInfo);
      } else if (
        !this.webinarInfo.isClosed &&
        !this.webinarInfo.unLimit &&
        this.webinarInfo.needRegistration &&
        !userInfo.isRegistration
      ) {
        await getUrl.goToSignUp(this.webinarInfo);
      } else {
        if (!this.webinarInfo.isReleased) {
          //会场未发布
          this.skWebinarUserChange({
            type: "kickOut",
            data: {
              needLogin: false,
              needSignUp: false,
              message: "很抱歉，会场未发布！",
            },
          });
          return;
        } else if (this.webinarInfo.isClosed) {
          if (this.webinarInfo.replaySwitch === 1) {
            console.log(this.webinarInfo.replaySwitch);
          } else {
            //会场已关闭
            if (this.webinarInfo.demandUrl) {
              // 已转点播
              // window.location.href = this.webinarInfo.demandUrl;
            } else {
              this.skWebinarUserChange({
                type: "kickOut",
                data: {
                  needLogin: false,
                  needSignUp: false,
                  message: "很抱歉，您来晚了，本场会议已经关闭",
                },
              });
              return;
            }
          }
        } else if (!this.webinarInfo.isOpen) {
          //会场未开放
          this.skWebinarUserChange({
            type: "kickOut",
            data: {
              needLogin: false,
              needSignUp: false,
              isOpen: false,
              message: "会场尚未开放，请您稍后再来",
            },
          });
          return;
        } else {
          //上面三个都不符合  进行如下操作 报名参加直播视频会议
          const params = {
            tenantId: this.webinarInfo.tenantId,
            instanceId: this.webinarInfo.instanceId,
            joinType: "1", //用户参会类型，1：登录用户 2：cookie用户 3：openId 4：其它用户（不支持）'
            openId: this.info.openId || "",
            url: window.location.href,
            referenceUrl: document.referrer,
            globalUserId: ck.cookie("globalUserId"),
            sess: userInfo.isLogin ? this.info.session : "",
          };
          if (window.location.href.indexOf("meetingInfo") == -1) {
            meetingService.join(params);
          }
        }
      }
      info.user.userInfoChange.next(userInfo);
      this.skWebinarUserChange({
        type: "change",
        data: userInfo,
      });
      this.skWebianrUserEnd(userInfo);
      info.user.userEnd.next(true);
    });
  }
  userLoad(webinar) {
    const defer = $.Deferred();
    this.info.temporaryUserName =
      ck.cookie("temporaryUserName_" + this.webinarInfo.webinarId) || "";
    this.info.cookie = (window as any).$sk.template.get().cookie.getSession();
    if (
      this.info.cookie != "" &&
      this.info.cookie != null &&
      this.info.cookie != "null"
    ) {
      this.info.isLogin = true;
      this.info.session = this.info.cookie.session;
    } else {
      this.info.isLogin = false;
      this.info.session = "";
    }
    const registrationInfo = ck.cookie(
      "registrationMember_" + this.webinarInfo.webinarId
    );
    //获取微信信息
    const tokenInfo = ck.cookie("verifyInfo_" + webinar.weChatId);
    if (tokenInfo) {
      this.info.nickName = tokenInfo.nickname;
      this.info.avatar = tokenInfo.avatar;
      this.info.openId = tokenInfo.original.openid;
    }
    meetingService
      .getSwebinarSignUpStatus({
        tenantId: this.webinarInfo.tenantId,
        webinarId: this.webinarInfo.webinarId,
        sess: this.webinarInfo.unLimit
          ? ""
          : this.info.cookie
          ? this.info.session
          : "",
        openId: this.webinarInfo.unLimit ? "" : this.info.openId || "",
        globalUserId: ck.cookie("globalUserId"),
      })
      .then((res) => {
        this.info.signUpTextStatus = res.content.statusMsg;
        this.info.signUpStatus = res.content.status;
        if (!!registrationInfo && registrationInfo != "null") {
          //  发送广播消息 参会人的信息
          this.setUserInfo(registrationInfo);
          //user
          ck.removeCookie(`registrationMember_${this.webinarInfo.webinarId}`, {
            path: "/",
            domain: sconf.domain,
          });
          defer.resolve(this.info);
        } else {
          if (this.info.isLogin) {
            meetingService
              .getMemberContacts({
                tenantId: this.webinarInfo.tenantId,
                webinarId: this.webinarInfo.webinarId,
                sess: this.info.session,
                isTemplate: 1,
                schemaId: this.webinarInfo.schemaId,
              })
              .then((data) => {
                if (data.result == "0") {
                  if (!this.info.avatar) {
                    if (
                      data.content.bindInfo &&
                      data.content.bindInfo.wechat &&
                      data.content.bindInfo.wechat.headImgUrl
                    ) {
                      this.info.avatar =
                        data.content.bindInfo.wechat.headImgUrl;
                    } else if (data.content.headImgUrl) {
                      this.info.avatar = data.content.headImgUrl;
                    }
                  }
                  this.info.userName = data.content.name;
                  //向模板发送 设置用户名称
                } else {
                  ck.cookie(
                    "smarketMember_" + this.webinarInfo.schemaId,
                    null,
                    {
                      domain: (window as any).$sk.config.domain,
                      path: "/",
                    }
                  );
                }
              });
          }
          meetingService
            .getContacts({
              tenantId: this.webinarInfo.tenantId,
              webinarId: this.webinarInfo.webinarId,
              sess: this.webinarInfo.unLimit
                ? ""
                : this.info.cookie
                ? this.info.session
                : "",
              openId: this.webinarInfo.unLimit ? "" : this.info.openId || "",
              globalUserId: ck.cookie("globalUserId"),
            })
            .then((data) => {
              //发送通知 用户信息
              this.setUserInfo(data.content);
              this.info.isShow = true;
              this.skWebinarUserChange({
                type: "setUserName",
                name: this.info.name,
              });
              if (
                !this.webinarInfo.isClosed &&
                this.webinarInfo.isReleased &&
                !this.info.isRegistration
              ) {
                if (
                  (!this.webinarInfo.needRegistration && this.info.isLogin) ||
                  this.webinarInfo.unLimit
                ) {
                  return this.silentSignUp(this.webinarInfo, this.info).then(
                    () => {
                      defer.resolve(this.info);
                    },
                    () => {
                      defer.reject({
                        desc: "静默报名失败",
                      });
                    }
                  );
                } else {
                  defer.resolve(this.info);
                }
              } else {
                defer.resolve(this.info);
              }
            });
        }
      });

    return defer.promise();
  }

  setUserInfo(user) {
    if (user) {
      this.info.name = "";
      this.info.id = user.signUpId;
      this.info.memberId = user.signUpId;
      this.info.applicantId = user.signUpId;
      this.info.uid = (1000000000 + parseInt(user.signUpId)).toString();
      this.info.isRegistration = parseInt(user.isSignUp) === 1;
      this.info.hasPermission = parseInt(user.permission) === 1;
      this.info.permission = user.permission;
      this.info.isDelete = parseInt(user.isDelete) === 1;
      if (user.contact) {
        const mobile = user.contact.mobile
          ? this.encryptUserInfo(user.contact.mobile.toString(), "mobile")
          : null;
        const userName =
          !user.isUnLimit &&
          !user.contact.name &&
          !user.contact.mobile &&
          !user.contact.email
            ? "****"
            : null;
        this.info.name =
          this.info.userName ||
          this.info.nickName ||
          user.contact.name ||
          mobile ||
          this.encryptUserInfo(user.contact.email, "email") ||
          userName ||
          this.info.temporaryUserName ||
          "匿名用户_" + this.info.id;
        this.info.email = user.contact.email;
        this.info.mobile = user.contact.mobile;
        this.info.company = user.contact.enterprise;
        this.info.position = user.contact.position;
      }
      this.info.channel = user.channel;
      this.info.clientType = this.isMobile ? "mobile" : "pc";
      //（0：否， 1：是）
      this.info.isUnLimit = user.isUnLimit;
      this.info.markCode = user.markCode;
    } else {
      this.info.isRegistration = false;
      this.info.hasPermission = false;
      this.info.isDelete = false;
    }
  }

  //静默报名
  silentSignUp(webinar, user) {
    const defer = $.Deferred();
    /** 检查是否报名 */
    this.checkRegistration(webinar, user)
      .then((data) => {
        return this.gotoSilentSignUp(webinar, user, data);
      })
      .then((data) => {
        //会议是无限制观看的时候 不再去拿人的信息
        if (webinar.unLimit) {
          const obj = {
            permission: 1,
            isDelete: 0,
            signUpId: data.content.signUpId,
            isUnLimit: 1,
            isFrozen: 1,
            formData: null,
          };
          this.setUserInfo(obj);
          this.skWebinarUserChange({
            type: "setUserName",
            name: "匿名用户_" + data.content.signUpId,
          });
        } else {
          return this.userLoad(this.webinarInfo);
        }
      })
      .then(
        (data) => {
          defer.resolve(data);
        },
        (error) => {
          defer.reject(error);
        }
      );

    return defer.promise();
  }

  //静默报名
  gotoSilentSignUp(webinar, user, data) {
    const defer = $.Deferred();
    /** 检查是否报名 */
    const params = {
      webinarId: URLS.getURL("webinarId"),
      moduleId: 2,
      tenantId: webinar.tenantId,
      formId: webinar.isSilent ? this.customFormId : 0,
      channel: this.tc || "",
      globalUserId: ck.cookie("globalUserId"),
      weChatId: webinar.weChatId || "",
      openId: webinar.unLimit ? "" : user.openId || "",
      sess: webinar.unLimit ? "" : user.cookie ? user.cookie.session : "",
      isPreview: "0",
      signUpSource: this.isMobile ? "WAP" : "PC",
      isUnLimit: webinar.unLimit ? 1 : 0, //无限制观看静默报名 1 是 0 否
      // markCode 与 marketingSess 为用于统计的埋点相关参数
      markCode: this.markCode || "",
      markType: URLS.getURL("markType") || "",
      //      _isAsync: true, //只应用于无限制观看下的静默报名
      marketingSess: ck.cookie("marketingSess") || "",
      formData: null,
    };
    if (data && data.content.formData && data.content.formData.length > 0) {
      params.formData = data.content.formData;
    }
    meetingService.silentSignUp(params).then((data) => {
      defer.resolve(data);
    });
    return defer.promise();
  }

  //检查是否报名
  checkRegistration(webinar, user) {
    const defer = $.Deferred();
    /** 检查是否报名 */
    meetingService
      .checkRegistration({
        customFormId: this.customFormId,
        cookieId: ck.cookie("globalUserId").replace(/"/g, ""),
        instanceId: webinar.instanceId,
        openId: user.openId || "",
        sess: user.cookie ? user.cookie.session : "",
        includeFormData: 1,
        tenantId: webinar.tenantId,
      })
      .then((data) => {
        defer.resolve(data);
      });
    return defer.promise();
  }

  // 处理人的 敏感信息
  encryptUserInfo(val, type) {
    //手机号变成 150****1233
    const encryptor = {
      email: function (val) {
        const prefix = val.replace(/^(.*)@.*$/, "$1");
        if (prefix.length < 5) {
          return val.replace(/^[^@]*@(.*)$/, "****@$1");
        }
        return val.replace(/^(\w{2}).*(\w{2})@(.*)$/, "$1****$2@$3");
      },
      qq: function (val) {
        if (val.length < 4) {
          return val[0] + "****";
        }
        return val.replace(/^(\d{2})\d+(\d{2})$/, "$1****$2");
      },
      mobile: function (val) {
        if (val.length !== 11) {
          return val.replace(/^(.*)([\w]{4})$/, "****$2");
        }
        return val.replace(/^(\w{3})\w{4}(\w{4})$/, "$1****$2");
      },
    };

    if (!encryptor[type]) {
      return;
    }
    if (!val) {
      return;
    }
    return encryptor[type](val);
  }
  skWebianrUserEnd(data) {
    cr.each(User.modules, (d) => {
      if (d.model.skWebianrUserEnd) {
        d.model.skWebianrUserEnd(data);
      }
    });
  }

  skWebinarUserChange(data) {
    cr.each(User.modules, (d) => {
      if (d.model.skWebinarUserChange) {
        d.model.skWebinarUserChange(data);
      }
    });
  }

  skUserEvent(o: UserEventParameter) {
    switch (o.type) {
      case "userCanJoin":
        return this.init(o.data);
        break;
    }
  }
}

export { User };
